module.exports = __webpack_public_path__ + "img/ig-black.7cdb3871.svg";